import { DataGuard } from '@components/DataGuard'
import { Match, Switch } from 'solid-js'
import { useService } from 'solid-services'
import { Box } from 'styled-system/jsx'
import { useSingle } from '../state'
import Analysis from './Analysis'
import AppBar from './AppBar'
import Discussion from './Discussion'
import StickyBar from './StickyBar'

export default function Mobile() {
  const { setupQuery, activeView } = useService(useSingle)()

  return (
    <DataGuard query={setupQuery}>
      {(setup) => (
        <Box display="flex" flexDirection="column" minHeight="0">
          <AppBar setup={setup} />
          <StickyBar />
          <Switch>
            <Match when={activeView() === 'analysis'}>
              <Analysis />
            </Match>
            <Match when={activeView() === 'discussion'}>
              <Discussion />
            </Match>
          </Switch>
        </Box>
      )}
    </DataGuard>
  )
}
